import React from "react"
import { Bar } from 'react-chartjs-2'

const Chart = ({
                 translations,
                 title,
                 forecast_location,
                 labels,
                 caqi_pm10,
                 caqi_pm25,
                 pm10,
                 pm25,
                 colors,
                 date = null,
                 onMap = false
               }) => {
  const chartData = {
    labels: labels,
    datasets: [{
      data: caqi_pm10,
      caqi_pm25: caqi_pm25,
      pm10: pm10,
      pm25: pm25,
      backgroundColor: colors,
      borderWidth: 1
    }]
  }

  const chartUrl = () =>
    `${location.href}/${forecast_location.toLowerCase()}`

  const chartTitle = () => {
    if (date) {
      let d = new Date()
      d.setTime(Date.parse(date))
      // return `${d.toLocaleDateString()}`
      // return `${date.toLocaleString(translations.locale)}`
      return `${translations.forecast_for} ${d.toLocaleDateString(translations.locale)}`
    }

    if (!onMap) {
      return ``
    }
    return `${title}`
  }

  const options = {
    hover: {
      onHover: function (e) {
        if (!onMap) {
          e.target.style.cursor = 'default'
          return
        }
        const point = this.getElementAtEvent(e)
        if (point.length) e.target.style.cursor = 'default'
        else e.target.style.cursor = 'pointer'
      }
    },
    onClick() {
      if (!onMap) {
        return
      }
      location.href = chartUrl()
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      mode: 'index',
      displayColors: false,
      titleFontSize: 19,
      bodyFontSize: 19,
      callbacks: {
        title(tooltipItems, _data) {
          const date = new Date(tooltipItems[0].label)
          // return `${translations.forecast_for} ${date.toLocaleString(translations.locale)}`
          return `${date.toLocaleString(translations.locale)}`
        },
        label(tooltipItem, data) {
          return [
            // TODO i18n
            `PM10 CAQI: ${tooltipItem.value} (${data.datasets[0].pm10[tooltipItem.index]} µg/\u33a5)`,
            `PM2.5 CAQI: ${data.datasets[0].caqi_pm25[tooltipItem.index]} (${data.datasets[0].pm25[tooltipItem.index]} µg/\u33a5)`
          ]
        }
      }
    },
    title: {
      // display: true,
      position: 'left',
      // textAlign: 'left',
      // align: 'start',
      text: chartTitle(),
      fontSize: 21
    },
    legend: {
      display: false,
    },
    scales: {
      xAxes: [{
        gridLines: {
          drawOnChartArea: false
        },
        ticks: {
          enabled: true,
          autoSkip: false,
          // maxRotation: onMap ? 0 : 45,
          maxRotation: 0,
          // fontStyle: "bold",
          fontSize: 15,
          callback: function (value, _index, _values) {
            let d = new Date()
            d.setTime(Date.parse(value))
            let date = ""
            // if (!onMap) {
            //   date = d.toISOString().substring(0, 10)
            // }
            // if ([0].includes(d.getHours())) {
            //   return `${date} ${d.getHours()}:00` // return d.getHours()
            // }
            if ([0, 6, 12, 18].includes(d.getHours())) {
              return `${date} ${d.getHours()}:00` // return d.getHours()
              // return `${d.getHours()}:00` // return d.getHours()
            }
            return ''
          }
        }
      }],
      yAxes: [{
        display: false,
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 5
        }
      }]
    }
  }

  // const chartValid = true
  // if (!chartValid) {
  //   return null
  // }

  return (
    <Bar data={chartData} options={options}/>
  )
}

export default Chart
